import React from "react"
import PropTypes from "prop-types"
import OnVisible from "react-on-visible"
import "../css/social-slider.css"

var timeOut
var height
var position

class SocialSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: 0,
    }
    this.myRef = React.createRef()
    this.handleScroll = this.handleScroll.bind(this)
  }

  handleActive() {
    if (timeOut) {
      clearTimeout(timeOut)
    }
    timeOut = setTimeout(() => {
      this.state.active < this.props.children.length - 1
        ? this.setState({
            active: this.state.active + 1,
          })
        : this.setState({ active: 0 })
    }, 5000)

    //return timer
  }

  handleClick() {
    clearTimeout(timeOut)
    this.state.active < this.props.children.length - 1
      ? this.setState({
          active: this.state.active + 1,
        })
      : this.setState({ active: 0 })

    this.handleActive()
  }

  handleImages() {
    var current = this

    if (current.props.children.length > 1) {
      return current.props.children.map(function (child, index) {
        return (
          <div
            key={index}
            className={index == current.state.active && "active"}
          >
            {" "}
            {child.props.image}
          </div>
        )
      })
    } else {
      return (
        <div className={"active"}>{current.props.children.props.image}</div>
      )
    }
  }

  handleText() {
    var current = this
    if (current.props.children.length > 1) {
      return current.props.children.map(function (child, index) {
        return (
          <div
            key={index}
            className={index == current.state.active ? "active text" : "text"}
          >
            {/*child.props.logo*/}
            <span className="copy">
              {" "}
              {child.props.title}
              {child.props.text}
            </span>
            <span className="index">
              {index + 1}/{current.props.children.length}
            </span>
          </div>
        )
      })
    } else {
      return (
        <div className={"active text"}>
          {/*current.props.children.props.logo*/}
          {console.log("!!!", current.props.children.length > 1)}
          <span className="copy">
            {" "}
            {current.props.children.props.title}
            {current.props.children.props.text}
          </span>
        </div>
      )
    }
  }

  handleScroll(event) {
    height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight

    position =
      ((this.myRef.current.getBoundingClientRect().bottom -
        this.myRef.current.getBoundingClientRect().top) /
        2 +
        this.myRef.current.getBoundingClientRect().top) /
      height
    console.log(position)

    if (window.innerWidth >= 1200) {
      this.myRef.current.childNodes[0].style.transform =
        "translateY(" + position * 50 + "%)"
    }
    this.myRef.current.childNodes[1]
      .querySelector(".active")
      .querySelector(".gatsby-image-wrapper").style.transform =
      "translateY(" + position * -20 + "%)"
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
    // console.log(this.myRef.current.getBoundingClientRect().left + window.scrollX, this.myRef.current.getBoundingClientRect().top + window.scrollY);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  render() {
    var current = this

    this.handleActive()
    return (
      <OnVisible className="social-slider-wrapper">
        <div ref={this.myRef}>
          <div className="text-wrapper">
            <div>
              {this.handleText()}

              {current.props.children.length > 1 && (
                <div onClick={() => this.handleClick()} className="flat-button">
                  Next Testimonial
                </div>
              )}
            </div>
          </div>
          <div className="images-wrapper">{this.handleImages()}</div>
        </div>
      </OnVisible>
    )
  }
}

SocialSlider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SocialSlider
